import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';

export class CulturalPracticeEntity implements Entity {
  public static fromXML(xml, matchIDs) {
    const attrs = xml._attributes;
    const designator = attrs[ATTRS.CulturalPractice.CulturalPracticeDesignator];
    const isoId = attrs[ATTRS.CulturalPractice.CulturalPracticeId];
    const id = matchIDs[isoId] ? matchIDs[isoId].id : null;
    return {
      entity: new CulturalPracticeEntity(id, designator),
      isoId: xml._attributes[ATTRS.CulturalPractice.CulturalPracticeId],
    };
  }
  public type = TAGS.CulturalPractice;

  constructor(
    public id: string,
    public designator: string
  ) {}

  public toXML(xmlId: string) {
    return {
      _attributes: {
        [ATTRS.CulturalPractice.CulturalPracticeId]: xmlId,
        [ATTRS.CulturalPractice.CulturalPracticeDesignator]: this.designator,
      },
    };
  }
}
